import {Injectable} from '@angular/core';
import {AbstractModelService} from '../model/abstract-model.service';
import {ApiClientService} from '../api-client/api-client.service';
import {SiteConfigParam} from '../../models/site-config-param';
import {AsyncSubject, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SiteConfigParamService extends AbstractModelService<SiteConfigParam> {

  private siteConfigParams = new AsyncSubject<SiteConfigParam[]>();

  constructor(apiClient: ApiClientService) {
    super(apiClient, '/site-config-param', SiteConfigParam);

    this.findAll().subscribe(siteConfigParams => {
      this.siteConfigParams.next(siteConfigParams);
      this.siteConfigParams.complete();
    });
  }

  getList(): Observable<SiteConfigParam[]> {
    return new Observable<SiteConfigParam[]>(observer => {
      this.siteConfigParams.subscribe((siteConfigParams) => {
        observer.next(siteConfigParams);
        observer.complete();
      });
    })
  }
}
